"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Contents;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Contents(_ref) {
  var children = _ref.children,
      subtext = _ref.subtext,
      buttonTitle = _ref.buttonTitle,
      icon = _ref.icon,
      iconAlt = _ref.iconAlt,
      image = _ref.image,
      imageAlt = _ref.imageAlt;

  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "div",
      { className: "article-image" },
      _react2.default.createElement("img", { src: image, alt: imageAlt })
    ),
    _react2.default.createElement(
      "div",
      { className: "article-content vertical-aligning" },
      _react2.default.createElement(
        "div",
        { className: "article-text" },
        _react2.default.createElement(
          "h2",
          null,
          _react2.default.createElement("img", { src: icon, alt: iconAlt }),
          subtext
        ),
        _react2.default.createElement(
          "h3",
          null,
          buttonTitle
        )
      ),
      children
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/MatchMe/components/Contents.jsx
// module id = 1091
// module chunks = 0